import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import LockedIcon from '../../icons/LockedIcon';
import UnlockedIcon from '../../icons/UnlockedIcon';
import ClockIcon from '../../icons/ClockIcon';
import AirportIcon from '../../icons/AirportIcon';
import HospitalIcon from '../../icons/HospitalIcon';
import EducationIcon from '../../icons/EducationIcon';
import OfficeIcon from '../../icons/OfficeIcon';
import { getOpenStatus } from './utils/workHours';

/** @type {FF.LocationsFilterMap} */
const FridgeAccessFilters = new Map([
  [
    'Public Fridge',
    {
      icon: <UnlockedIcon />,
      title: 'Public Fridge',
      subtitle: 'Open to everyone.',
      testFn: location =>
        location.type !== 'FRIDGE' ||
        location.locationConfigs.accessTo === 'Public',
    },
  ],
  [
    'Private Fridge',
    {
      icon: <LockedIcon style={{ position: 'relative', left: '-2px' }} />,
      title: 'Private Fridge',
      subtitle: 'Open to those with building access.',
      testFn: location =>
        location.type !== 'FRIDGE' ||
        location.locationConfigs.accessTo === 'Private',
    },
  ],
]);

/** @type {FF.LocationsFilterMap} */
const FridgeHoursFilters = new Map([
  [
    'Open Now',
    {
      icon: <ClockIcon />,
      title: 'Open Now',
      testFn: location =>
        Boolean(
          location.locationConfigs.workHours &&
            location.locationConfigs.timeZone &&
            getOpenStatus(
              // TODO: move this to gatsby-node
              JSON.parse(location.locationConfigs.workHours),
              location.locationConfigs.timeZone,
            )?.isOpenNow,
        ),
    },
  ],
]);

/** @type {FF.LocationsFilterMap} */
const FridgeLocationFilters = new Map([
  [
    'Airports',
    {
      title: 'Airports',
      icon: <AirportIcon />,
      testFn: location =>
        location.type !== 'FRIDGE' ||
        location.locationConfigs.vertical === 'Airport',
    },
  ],
  [
    'Hospitals',
    {
      title: 'Hospitals',
      icon: <HospitalIcon />,
      testFn: location =>
        location.type !== 'FRIDGE' ||
        location.locationConfigs.vertical === 'Healthcare',
    },
  ],
  [
    'Education',
    {
      title: 'Education',
      icon: <EducationIcon />,
      testFn: location =>
        location.type !== 'FRIDGE' ||
        location.locationConfigs.vertical === 'Education',
    },
  ],
  [
    'Office',
    {
      title: 'Office',
      icon: <OfficeIcon />,
      testFn: location =>
        location.type !== 'FRIDGE' ||
        location.locationConfigs.vertical === 'Office',
    },
  ],
]);

// TODO: implement CS-5115 so we can dynamically build this filter
// icons are commented out for now, many retailers dont have readable logos at this size
/** @type {FF.LocationsFilterMap} */
const RetailLocationFilters = new Map([
  [
    'Target',
    {
      title: 'Target',
      // icon: <TargetIcon />,
      testFn: location =>
        Boolean(
          location.type !== 'WHOLESALE' ||
            location.opportunityName?.startsWith('Target'),
        ),
    },
  ],
  [
    'Jewel Osco',
    {
      title: 'Jewel Osco',
      // icon: (
      //   <StaticImage
      //     alt="Logo for Jewel Osco"
      //     layout="constrained"
      //     placeholder="none"
      //     src="../../../assets/img/retail/jewel_osco.png"
      //     width={42}
      //     loading="lazy"
      //   />
      // ),
      testFn: location =>
        Boolean(
          location.type !== 'WHOLESALE' ||
            location.opportunityName?.startsWith('Jewel Osco'),
        ),
    },
  ],
  [
    'Amazon Go',
    {
      title: 'Amazon Go',
      // icon: (
      //   <StaticImage
      //     alt="Logo for Amazon Go"
      //     layout="constrained"
      //     placeholder="none"
      //     src="../../../assets/img/retail/amazon_go.png"
      //     width={42}
      //     loading="lazy"
      //   />
      // ),
      testFn: location =>
        Boolean(
          location.type !== 'WHOLESALE' ||
            location.opportunityName?.startsWith('AmazonGo') ||
            location.opportunityName?.startsWith('AMAZONGO'),
        ),
    },
  ],
  [
    'Hudson News',
    {
      title: 'Hudson News',
      // icon: NO ICON GIVEN FOR HUDSON
      testFn: location =>
        Boolean(
          location.type !== 'WHOLESALE' ||
            location.opportunityName?.startsWith('Hudson'),
        ),
    },
  ],
]);

const AllFilters = {
  'Fridge Access': FridgeAccessFilters,
  'Fridge Hours': FridgeHoursFilters,
  'Fridge Location Type': FridgeLocationFilters,
  'Retail Partners': RetailLocationFilters,
};

// these are unnecessary except that TS can't quite infer this all correctly when passed into reduce()
// update `paramToFilterKeyMap` if another filter is added
/** @type Array<FF.LocationsFilterType> */
const AllFiltersKeys = [
  'Fridge Access',
  'Fridge Hours',
  'Fridge Location Type',
  'Retail Partners',
];
const AllFiltersEmptyObj = {
  'Fridge Access': {},
  'Fridge Hours': {},
  'Fridge Location Type': {},
  'Retail Partners': {},
};

// eslint-disable-next-line import/prefer-default-export
export {
  AllFilters,
  AllFiltersKeys,
  AllFiltersEmptyObj,
  FridgeAccessFilters,
  FridgeHoursFilters,
  FridgeLocationFilters,
  RetailLocationFilters,
};
